import {Injectable} from '@angular/core';
import {ReactiveService} from '../reactive-service.abstract';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../src/environments/environment';
import {TimerangeModel} from './timerange.model';

@Injectable()
export class TimerangeApiService extends ReactiveService {
  private baseUrl = environment.backEndUrlPrefix + '/' + 'range_value';

  constructor(private http: HttpClient) {
    super();
  }

  create(data: TimerangeModel): Observable<TimerangeModel> {
    return this.http.post<TimerangeModel>(`${this.baseUrl}`, data);
  }
  save(data: TimerangeModel): Observable<TimerangeModel> {
    return this.http.put<TimerangeModel>(`${this.baseUrl}/${data.id}`, data);
  }

  delete(data: TimerangeModel): Observable<TimerangeModel> {
    return this.http.delete<TimerangeModel>(`${this.baseUrl}`, {params: {id: data.id}});
  }



}
